<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-01-09 14:13:28
 * @FilePath: \mrc-ess-fronted\src\Layout\components\changePassword.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-16 17:57:48
-->
<template>
  <normalDialog
    :title="$t('label_To_reset_your_password')"
    @close="closeDialog"
    width="680"
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form">
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <!-- :rules="$GetRules(['_Require_Rules'], [null])" -->
            <normalInputTextFiled
              :password="Data"
              :label="$t('label_OriginalPassword')"
              v-model="Data.originalP"
              :rules="regxRule"
              :type="Data.originalType"
              :placeholder="$t('label_OriginalPassword')"
            >
              <template v-slot:append>
                <span
                  class="material-icons-round"
                  @click="
                    Data.originalType == 'password'
                      ? (Data.originalType = 'text')
                      : (Data.originalType = 'password')
                  "
                  >{{
                    Data.originalType == "password"
                      ? "visibility"
                      : "visibility_off"
                  }}</span
                >
              </template>
            </normalInputTextFiled>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <!-- :rules="$GetRules(['_Require_Rules'], [null])" -->
            <normalInputTextFiled
              :password="Data"
              :type="Data.newType"
              :label="$t('label_newpassword')"
              :rules="newpasswordRegxRule"
              v-model="Data.newP"
              :placeholder="$t('label_newpassword')"
            >
              <template v-slot:append>
                <span
                  class="material-icons-round"
                  @click="
                    Data.newType == 'password'
                      ? (Data.newType = 'text')
                      : (Data.newType = 'password')
                  "
                  >{{
                    Data.newType == "password" ? "visibility" : "visibility_off"
                  }}</span
                >
              </template>
            </normalInputTextFiled>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <!-- :rules="$GetRules(['_Require_Rules'], [null])" -->
            <normalInputTextFiled
              :password="Data"
              :label="$t('label_Retypepassword')"
              :type="Data.renewType"
              :rules="retypepasswordRegxRule"
              v-model="Data.renewP"
              :placeholder="$t('label_Retypepassword')"
            >
              <template v-slot:append>
                <span
                  class="material-icons-round"
                  @click="
                    Data.renewType == 'password'
                      ? (Data.renewType = 'text')
                      : (Data.renewType = 'password')
                  "
                  >{{
                    Data.renewType == "password"
                      ? "visibility"
                      : "visibility_off"
                  }}</span
                >
              </template>
            </normalInputTextFiled>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions submitBtn @cancel="closeDialog" @submit="toSave" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "changePassword",
  props: {
    show: { default: false, type: Boolean },
  },
  computed: {
    ...mapGetters(["companyLang", "userInfo", "loginEncryptKey"]),
    curUserInfo() {
      return this.userInfo ? JSON.parse(this.$aesDecrypt(this.userInfo)) : null;
    },
  },
  watch: {
    show(val) {
      if (val) this.changePassword();
      if (!val) if (this.$refs["form"]) this.$refs["form"].reset();
    },
  },
  async created() {
    await this.$store.dispatch("getLoginEncryptKey");
  },
  data() {
    return {
      Data: {
        originalP: "",
        originalType: "password",
        newP: "",
        newType: "password",
        renewP: "",
        renewType: "password",
      },
      regxRule: [(v) => !!v || "Required."],
      newpasswordRegxRule: [(v) => !!v || "Required."],
      retypepasswordRegxRule: [
        (v) => !!v || "Required.",
        (v) => v === this.Data.newP || "密码不一致",
      ],
    };
  },
  created() {},
  methods: {
    async changePassword() {
      // this.$v.params.$reset()
      const res = await this.getPasswordStrength();
      // this.changePasswordDialog = true
    },
    async getPasswordStrength() {
      this.$Request({
        method: "POST",
        url: "/personalcenter/return-security/",
        data: {
          user_account: this.$loginEncrypt({
            msg: JSON.parse(this.$store.state.AppInfo).user.user_account,
            key: this.loginEncryptKey,
          }),
        },
        type: "lang",
        global: false,
      })
        .then((res) => {
          if (res.code == 200) {
            this.regxMsg = res.data.ceckmean;
            let RegExpRule = new RegExp(res.data.cecknum);
            // this.regxMsg = '"包含大写字母，包含小写字母，包含数字，包含特殊字符，需要8到20位有效是字符。"'
            // this.regxRule = [
            //   (v) => !!v || "Required.",
            //   (v) => RegExpRule.test(v) || this.regxMsg,
            // ];
            this.newpasswordRegxRule = [
              (v) => !!v || "Required.",
              (v) => RegExpRule.test(v) || this.regxMsg,
            ];
            this.retypepasswordRegxRule = [
              (v) => !!v || "Required.",
              (v) => RegExpRule.test(v) || this.regxMsg,
              (v) => v === this.Data.newP || "两次输入密码不一致",
            ];
          }
        })
        .catch((err) => {
          // let RegExpRule = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~.\/({\\\[\\\]})|<>#?!@$%^&*=+-])(.{8,20}$)')
          // this.regxMsg = '"包含大写字母，包含小写字母，包含数字，包含特殊字符，需要8到20位有效是字符。"'
          // this.regxRule = [
          //   v => !!v || 'Required.',
          //   v => RegExpRule.test(v) || this.regxMsg
          // ]
          // this.newpasswordRegxRule = [
          //   v => !!v || 'Required.',
          //   v => RegExpRule.test(v) || this.regxMsg,
          // ]
          // this.retypepasswordRegxRule = [
          //   v => !!v || 'Required.',
          //   v => RegExpRule.test(v) || this.regxMsg,
          //   v => v === this.Data.newP || '两次输入密码不一致'
          // ]
        });
    },
    // ----------
    closeDialog: function () {
      this.$emit("close");
    },
    toSave: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      if (this.Data.originalP !== this.curUserInfo["mrc_password"]) {
        //密码错误
        this.$showMessage({
          text: this.$t("error_SYSTEM_OLD_PASSWORD_ERROR"),
          type: "warning",
        });
        return false;
      }
      if (this.Data.originalP === this.Data.newP) {
        //相同密码
        this.$showMessage({
          text: this.$t("error_SYSTEM_UPDATE_PWD_REPEAT"),
          type: "warning",
        });
        return false;
      }
      if (this.Data.newP !== this.Data.renewP) {
        //两次输入不一致
        this.$showMessage({
          text:
            this.$t("verify_Entered_twice") + this.$t("verify_Inconsistent"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onSubmit", this.Data);
    },
  },
};
</script>